import {
  AtomicBlockUtils,
  Entity
} from 'draft-js';

let count = 0;

const examples = ['P(E) = click-to-\\frac{create}{edit}-your-formula'];

export function insertTeXBlock(editorState) {
  const nextFormula = count++ % examples.length;
  const entityKey = Entity.create(
    'TeX', //TOKEN
    'IMMUTABLE',
    {content: examples[nextFormula]}
  );

  return AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
}



/** WEBPACK FOOTER **
 ** ./src/components/TeXEditor/modifiers/insertTeXBlock.js
 **/